var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M44.691 62.822 66.843 38.8l4.197 3.844-29.876 32.487h-2.328L8.924 42.681l4.021-3.88 22.293 24.056a7.6 7.6 0 0 1 1.658 2.646V4.833h6.173v60.67a8.2 8.2 0 0 1 1.622-2.681"
  })));
};
export default SvgDownArrow;